import { render, staticRenderFns } from "./HomeWhereYouBelong.vue?vue&type=template&id=4ff464dd&scoped=true"
import script from "./HomeWhereYouBelong.vue?vue&type=script&lang=js"
export * from "./HomeWhereYouBelong.vue?vue&type=script&lang=js"
import style0 from "./HomeWhereYouBelong.vue?vue&type=style&index=0&id=4ff464dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff464dd",
  null
  
)

export default component.exports